import { render, staticRenderFns } from "./ParticipantDSP.vue?vue&type=template&id=4b252307"
import script from "./ParticipantDSP.vue?vue&type=script&lang=js"
export * from "./ParticipantDSP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports